import { render, staticRenderFns } from "./MdSvgLoader.vue?vue&type=template&id=7b35dd71"
import script from "./MdSvgLoader.vue?vue&type=script&lang=js"
export * from "./MdSvgLoader.vue?vue&type=script&lang=js"
import style0 from "./MdSvgLoader.vue?vue&type=style&index=0&id=7b35dd71&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports